import { makeAutoObservable } from 'mobx'
import { memberMobx } from '../rootMobx'
import { storeMobx, restaurantConfig } from 'restaurant'
import { MoApi } from '@api/index'

class VirtualOrderStore {
  constructor () {
    makeAutoObservable(this, {}, { autoBind: true })
  }
  // 会员卡续费单
  async placeMcRenewOrder (type: 'memberCardRenew' | 'memberCardBuy', cardInfo: {
    cardNo: string | number;
    cardId: number;
    cardName: string;
  }, rechargeInfo: {
    cardRechargeId?: number;
    money: number;
    paidFee: number;
    storeId?: number;
  }, groupInfo?: {
    groupBuyActivityId?: number;
    groupBuyId?: number;
  }) {
    const orderParams = this.getMcRenewOrder(type, cardInfo, rechargeInfo, groupInfo)
    return this.placeVirtualOrder(orderParams)
  }
  getMcRenewOrder (type: 'memberCardRenew' | 'memberCardBuy', cardInfo: {
    cardNo: string | number;
    cardId: number;
    cardName: string;
  }, rechargeInfo: {
    cardRechargeId?: number;
    money: number;
    paidFee: number;
    storeId?: number;
    discount?: any;
    memberGroupId?: number;
  }, groupInfo?: {
    groupBuyActivityId?: number;
    groupBuyId?: number;
  }) {
    const orderList: any = [{
      type: type,
      cnt: 1,
      productCategoryNo: type,
      productNo: cardInfo.cardNo,
      productName: cardInfo.cardName,
      productScaleNo: rechargeInfo.cardRechargeId ? `${rechargeInfo.cardRechargeId}` : '0',
      paidFee: rechargeInfo.paidFee,
      originalFee: rechargeInfo.money,
      productExt: JSON.stringify({
        cardId: cardInfo.cardId,
      })
    }]
    const orderParams: any = {
      paidFee: rechargeInfo.paidFee,
      totalFee: rechargeInfo.money,
      details: orderList,
      eatType: type,
      contactInfo: '',
      storeId: rechargeInfo.storeId || 0
    }
    if (groupInfo) orderParams.groupInfo = groupInfo
    if (rechargeInfo.discount) orderParams.discount = rechargeInfo.discount
    if (rechargeInfo.memberGroupId) orderParams.memberGroupId = rechargeInfo.memberGroupId
    return orderParams
  }
  // 会员卡充值单
  async placeMcRechargeOrder (cardInfo: {
    cardNo: string;
    cardName: string;
  }, rechargeInfo: {
    cardRechargeId?: number;
    money: number;
    storeId?: number;
  }) {
    const orderParams = this.getMcRechargeOrder(cardInfo, rechargeInfo)
    return this.placeOrder(orderParams)
  }
  getMcRechargeOrder (cardInfo: {
    cardNo: string;
    cardName: string;
    mobilePayBackJumb?: string;
  }, rechargeInfo: {
    cardRechargeId?: number;
    money: number;
    storeId?: number;
  }) {
    const orderList: any = [{
      type: 'memberCz',
      cnt: 1,
      productCategoryNo: 'memberCardRecharge',
      productNo: cardInfo.cardNo,
      productName: cardInfo.cardName,
      productScaleNo: rechargeInfo.cardRechargeId ? `${rechargeInfo.cardRechargeId}` : '0',
      paidFee: rechargeInfo.money,
      originalFee: rechargeInfo.money
    }]
    const orderParams: any = {
      totalFee: rechargeInfo.money,
      paidFee: rechargeInfo.money,
      details: orderList,
      eatType: 'memberCz',
      contactInfo: '',
      storeId: rechargeInfo.storeId || 0
    }
    if (cardInfo?.mobilePayBackJumb) orderParams.mobilePayBackJumb = cardInfo.mobilePayBackJumb
    return orderParams
  }
  // 礼品卡充值单
  async placeGcRechargeOrder (cardInfo: {
    cardNo: string;
    giftcardId: number;
    giftcardName: string;
  }, rechargeInfo: {
    cardRechargeId?: number;
    recharge: number;
    storeId?: number;
  }) {
    const orderParams = this.getGcRechargeOrder(cardInfo, rechargeInfo)
    return this.placeOrder(orderParams)
  }
  getGcRechargeOrder (cardInfo: {
    cardNo: string;
    giftcardId: number;
    giftcardName: string;
  }, rechargeInfo: {
    cardRechargeId?: number;
    recharge: number;
    storeId?: number;
    reloadType?: string;
  }) {
    const orderList: any = [
      {
        type: 'giftcardCz',
        cnt: 1,
        productCategoryNo: 'giftCardRecharge',
        productNo: cardInfo.cardNo,
        productName: cardInfo.giftcardName,
        productScaleNo: rechargeInfo.cardRechargeId ? `${rechargeInfo.cardRechargeId}` : '0',
        paidFee: rechargeInfo.recharge,
        originalFee: rechargeInfo.recharge,
        ...(rechargeInfo.reloadType ? { productExt: JSON.stringify({ reloadType: rechargeInfo.reloadType }) } : {})
      }
    ]
    const orderParams: any = {
      totalFee: rechargeInfo.recharge,
      paidFee: rechargeInfo.recharge,
      details: orderList,
      eatType: 'giftcardCz',
      contactInfo: JSON.stringify({
        giftcardId: cardInfo.giftcardId,
      }),
      storeId: rechargeInfo.storeId || 0
    }
    return orderParams
  }
  // 下单
  async placeOrder (params: any) {
    const { brandId } = storeMobx.brand
    const { memberId } = memberMobx.memberInfo
    const { info: store } = storeMobx
    const { payMode } = store
    const obj: any = {
      infos: {
        brandId,
        storeId: params.storeId || 0,
        bo: window.bo,
        channel: 'mobile',
        payMode,
        eatType: params.eatType,
        appType: 'mobile',
        sourceType: 'onlineMobileWebH5',
        managerId: restaurantConfig.managerId,
        managerName: restaurantConfig.managerName,
        addUserId: restaurantConfig.managerId,
        addUserName: restaurantConfig.managerName,
        originalFee: params.totalFee,
        paidFee: params.totalFee,
        contactInfo: params.contactInfo,
      },
      ordersDetails: params.details,
    }
    if (memberId !== 0) {
      obj.infos.memberId = memberId
    }
    if (params?.mobilePayBackJumb) obj.infos.mobilePayBackJumb = params.mobilePayBackJumb
    let res: any
    try {
      res = await MoApi.placeTopup(obj)
    } catch (error) {
      return error
    }
    return res
  }

  // 虚拟订单
  async placeVirtualOrder (params: {
    eatType: string;
    totalFee: number;
    storeId?: number;
    paidFee: any;
    contactInfo?: string;
    details: any[];
    groupInfo?: any;
    discount?: any;
    memberGroupId?: number;
  }) {
    const { brandId } = storeMobx.brand
    const { memberId } = memberMobx.memberInfo
    const { info: store } = storeMobx
    const { payMode } = store
    const obj: any = {
      infos: {
        brandId,
        storeId: params.storeId || 0,
        bo: window.bo,
        channel: 'mobile',
        payMode,
        eatType: params.eatType,
        appType: 'mobile',
        sourceType: 'onlineMobileWebH5',
        managerId: restaurantConfig.managerId,
        managerName: restaurantConfig.managerName,
        addUserId: restaurantConfig.managerId,
        addUserName: restaurantConfig.managerName,
        originalFee: params.totalFee,
        paidFee: params.paidFee,
        contactInfo: params.contactInfo || '',
      },
      ordersDetails: params.details,
    }
    if (params.discount) {
      obj.discount = params.discount
    }
    if (params.memberGroupId) {
      obj.infos.memberGroupId = params.memberGroupId
    }
    if (params.groupInfo) {
      obj.groupBuyActivityId = params.groupInfo?.groupBuyActivityId || null
      obj.groupBuyId = params.groupInfo?.groupBuyId || null
    }
    if (memberId !== 0) {
      obj.infos.memberId = memberId
    }
    let res: any
    try {
      res = params.groupInfo ? await MoApi.placeGroupBuy(obj) : await MoApi.placeGoods(obj)
    } catch (error) {
      return error
    }
    return res
  }
  // 订单详情
  async getVirtualOrder (orderId: string) {
    let res: any
    let detail: IGiftCardOrderDetail
    const { storeId } = storeMobx.info
    const { brandId } = storeMobx.brand
    const para: any = {
      brandId,
      storeId,
      ordersId: orderId,
      withPrint: 0,
    }
    try {
      res = await MoApi.getOrderDetail(para)
      const { eatType, brandId, storeId, memberId, ordersId, paidFee, detailList, contactInfo } = res
      detail = {
        brandId,
        storeId,
        memberId,
        ordersId: ordersId,
        amount: paidFee,
        orderDetail: detailList,
        extra: {
          eatType,
        },
      }
      if (contactInfo) {
        detail.extra.email = JSON.parse(contactInfo).email || ''
        detail.extra.message = JSON.parse(contactInfo).message || ''
      }
    } catch (error) { }
    return detail
  }

  async getOrderDetail (orderId: string) {
    let res: any
    const { storeId } = storeMobx.info
    const { brandId } = storeMobx.brand
    const para: any = {
      brandId,
      storeId,
      ordersId: orderId,
      showPic: 1,
      withPrint: 0,
    }
    try {
      res = await MoApi.getOrderDetail(para)
    } catch (error) { }
    return res
  }
  // 发起支付
  async startPay (params: {
    orderId: string;
    storeId: number;
  }): Promise<any> {
    const para = {
      storeId: params.storeId || 0,
      brandId: storeMobx.brand.brandId,
      ordersId: params.orderId,
      clientNumber: restaurantConfig.deviceId || '',
    }
    return MoApi.startPay(para).then((res: any) => {
      if (res && res.result) {
        return res.result
      } else {
        throw new Error(res)
      }
    }).catch(err => {
      if (err && err.code === -160) {
        return
      } else {
        throw err
      }
    })
  }
}

const virtualOrderStore = new VirtualOrderStore()

export default virtualOrderStore
